export default "__VITE_ASSET__BJzJ8HdM__"